import { createDeskworksClient } from '@deskworks/api-client';
import { getToken } from '@/lib/api';

/** A guest of a shared desk (docs/features/desk-sharing.md): their way in on this device, one per desk. */
const key = (deskId: string) => `deskworks.guest.${deskId}`;

export function guestToken(deskId: string): string | null {
  try {
    return localStorage.getItem(key(deskId));
  } catch {
    return null;
  }
}

export function setGuestToken(deskId: string, token: string | null) {
  try {
    if (token) localStorage.setItem(key(deskId), token);
    else localStorage.removeItem(key(deskId));
  } catch {
    /* storage unavailable: the guest opens the link again next time */
  }
}

/**
 * The client a guest page calls with: the guest token of this device, else the person's own sign-in (a registered
 * guest). A refused token doesn't sign the person out of Deskworks; the page asks to open the link again.
 */
export function guestClient(deskId: string, onUnauthorized: () => void) {
  return createDeskworksClient({ baseUrl: '', getToken: () => guestToken(deskId) ?? getToken(), onUnauthorized });
}

export type GuestClient = ReturnType<typeof guestClient>;
